// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__LnUMG","Open":"SideDrawer_Open__1pWGy","Close":"SideDrawer_Close__2SaEA","Logo":"SideDrawer_Logo__3zgsx"};